import { render } from "./SearchTickets.vue?vue&type=template&id=52451d74&scoped=true&lang=pug"
import script from "./SearchTickets.vue?vue&type=script&lang=ts"
export * from "./SearchTickets.vue?vue&type=script&lang=ts"

import "./SearchTickets.vue?vue&type=style&index=0&id=52451d74&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-52451d74"

export default script